import React from 'react';

import { RichTextBlockData } from 'api/cms';
import { RichText } from 'components/Text';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const RichTextBlock = ({
  blockIndex,
  data: { html },
  fullWidthLayout,
  isSidebar,
}: {
  blockIndex: number;
  data: RichTextBlockData;
  fullWidthLayout?: boolean;
  isSidebar?: boolean;
}) => (
  <RichText
    dangerouslySetInnerHTML={{
      __html: html,
    }}
    textAlign={fullWidthLayout && 'center'}
    small={isSidebar}
    analyticsData={{
      eventName: 'CMS Block',
      eventProperties: {
        block_position: blockIndex,
        block_type: 'Rich Text',
      },
    }}
  />
);

export default RichTextBlock;
